import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M3.33334 9.58335V4.76028C3.33334 4.2087 3.33334 3.93291 3.37958 3.70318C3.5831 2.69188 4.42688 1.90084 5.5056 1.71003C5.75064 1.66669 6.04482 1.66669 6.63318 1.66669C6.89096 1.66669 7.01985 1.66669 7.14372 1.67755C7.67778 1.72437 8.18436 1.92108 8.59731 2.24201C8.69309 2.31645 8.78423 2.40189 8.96651 2.57278L9.33334 2.91669C9.8772 3.42655 10.1491 3.68148 10.4748 3.85133C10.6536 3.94463 10.8434 4.01831 11.0402 4.07092C11.3986 4.16669 11.7832 4.16669 12.5523 4.16669H12.8014C14.5563 4.16669 15.4338 4.16669 16.0041 4.6476C16.0566 4.69184 16.1065 4.73865 16.1537 4.78783C16.6667 5.32253 16.6667 6.14515 16.6667 7.79038V9.58335",
  stroke: "#4B4B4B",
  "stroke-width": "1.25"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M8.33334 14.1667H11.6667",
  stroke: "#4B4B4B",
  "stroke-width": "1.25",
  "stroke-linecap": "round"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M2.89728 14.5699C2.49965 12.3065 2.30083 11.1748 2.78256 10.3609C2.9055 10.1531 3.0571 9.96515 3.23257 9.80281C3.92017 9.16669 5.03158 9.16669 7.25442 9.16669H12.7456C14.9684 9.16669 16.0798 9.16669 16.7674 9.80281C16.9429 9.96515 17.0945 10.1531 17.2174 10.3609C17.6992 11.1748 17.5004 12.3065 17.1027 14.5699C16.8165 16.1993 16.6733 17.014 16.1775 17.5546C16.0488 17.6949 15.9048 17.8192 15.7485 17.9251C15.1458 18.3334 14.3457 18.3334 12.7456 18.3334H7.25442C5.65425 18.3334 4.85417 18.3334 4.25152 17.9251C4.09517 17.8192 3.95121 17.6949 3.82255 17.5546C3.32665 17.014 3.18353 16.1993 2.89728 14.5699Z",
  stroke: "#4B4B4B",
  "stroke-width": "1.25"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}